import Modal from '@/core/components/Modal/Modal';

export default Modal;
